<template>
    <svg
        class="v-icon mdi-icon theme--light"
        :viewBox="viewBox"
        :fill="fill"
        :height="size"
        :width="size"
        :style="{ transform: `rotate(${rotate}deg)` }"
    >
        <path :d="icon" />
    </svg>
</template>

<script>
import camelcase from "camelcase";
import {
    mdiAbTesting,
    mdiAccountBoxMultipleOutline,
    mdiAccountOutline,
    mdiArrowCollapseVertical,
    mdiArrowExpand,
    mdiArrowRightCircle,
    mdiArrowSplitHorizontal,
    mdiBookmark,
    mdiBookmarkMultipleOutline,
    mdiBookmarkPlusOutline,
    mdiCellphone,
    mdiCheckerboard,
    mdiChevronLeft,
    mdiChevronLeftCircleOutline,
    mdiChevronRight,
    mdiChevronRightCircleOutline,
    mdiCompare,
    mdiEmoticonHappyOutline,
    mdiEmoticonSadOutline,
    mdiFilterOutline,
    mdiFolderMultipleOutline,
    mdiFormatListBulletedSquare,
    mdiForumOutline,
    mdiGrid,
    mdiGridLarge,
    mdiHeart,
    mdiHeartMultipleOutline,
    mdiHeartOutline,
    mdiHelpCircleOutline,
    mdiHomeOutline,
    mdiImageOutline,
    mdiLock,
    mdiLockOpenVariant,
    mdiMenuDown,
    mdiPalette,
    mdiPlayBoxOutline,
    mdiPrinter,
    mdiRestore,
    mdiStarOutline,
    mdiStar,
    mdiThumbDownOutline,
    mdiThumbUpOutline,
    mdiThumbDown,
    mdiThumbUp,
    mdiToothOutline,
    mdiTooth,
    mdiTrashCanOutline,
    mdiTrophyVariant,
    mdiViewAgendaOutline,
    mdiRadioboxMarked,
    mdiRadioboxBlank,
    mdiSale,
    mdiCheck,
    mdiFullscreen,
    mdiFullscreenExit,
    mdiWalletGiftcard,
    mdiBarcodeScan,
    mdiContentSaveOutline,
    mdiEmailSendOutline,
    mdiFolderClockOutline,
    mdiEmailOutline,
    mdiEmailOpenOutline,
    mdiCommentProcessingOutline,
    mdiTrophyOutline,
    mdiAlertDecagramOutline,
    mdiHistory,
    mdiCreditCardOutline,
    //mdiFilePdfOutline,
    mdiFileOutline,
    mdiMovieOpenPlayOutline,
    mdiCalculatorVariantOutline,
    mdiGiftOutline,
    mdiSpeedometer,
    mdiAlert,
    mdiAlertOutline,
    mdiPlay,
    mdiPlayCircleOutline,
    mdiHumanMaleBoard,
    mdiFileDocumentOutline,
    mdiCheckboxBlankOutline,
    mdiCheckboxMarkedOutline ,
mdiCommentOutline,
} from "@mdi/js";

// Utility function.
const isDef = (value) => typeof value !== "undefined";

/** @type {string} */
const mdiPlanmasterLogo =
  "M6.45 20.13a.8.8 0 01-.46-.47.6.6 0 010-.43.86.86 0 01.4-.46c.11-.04.23-.05 1.52-.06l1.4-.01.12-.08c.44-.25.5-.82.14-1.15-.2-.17-.25-.18-.93-.2-.57-.01-.62-.02-.74-.09a.7.7 0 01-.41-.64c0-.28.12-.5.36-.62l.12-.08 1.36-.01 1.37-.02.15-.08a.75.75 0 00.37-1 .75.75 0 00-.39-.4l-.13-.06-2.94-.02c-2.7 0-2.95-.02-3.05-.06a.67.67 0 01-.35-.33.72.72 0 01.32-.95c.1-.07.12-.07 2.4-.08 1.86 0 2.3-.02 2.35-.05.2-.12.38-.4.38-.62 0-.27-.2-.55-.44-.66l-.14-.07H6.66c-2.85-.01-2.72 0-2.92-.21a.75.75 0 01-.19-.76c.04-.13.2-.33.36-.41l.1-.06h3.37l3.34-.02.16-.08a.8.8 0 00.23-.16.72.72 0 00-.25-1.13l-.14-.07-1.66-.01C7.42 8.5 7.41 8.5 7.3 8.44a.74.74 0 01-.39-.56.77.77 0 01.37-.72l.14-.07.9-.01.92-.02.15-.08c.2-.1.34-.25.4-.45.07-.28 0-.51-.21-.72-.23-.2-.23-.2-1.81-.2-1.34 0-1.4 0-1.51-.07a.72.72 0 01-.21-1.17c.23-.24.02-.22 3.06-.24 2.92-.03 3.03-.01 3.56.14a3.6 3.6 0 011.13.59 3.9 3.9 0 001.55.85c.34.08.93.11 1.27.07.55-.08 1.1-.32 1.58-.69.52-.39.66-.5.94-.62A3.27 3.27 0 0123.8 6.9c.04.23.04.78.03 5.36 0 4.6-.01 5.13-.05 5.38-.23 1.37-.94 2.25-2 2.46-.5.1-.83.09-1.22-.05A2.98 2.98 0 0119.33 19a20.18 20.18 0 01-1.98-4.15c-.2-.56-.42-.93-.62-1.07a.78.78 0 00-.58-.2c-.31 0-.46.07-.68.3-.24.24-.34.48-.76 1.72l-.55 1.56c-.74 1.96-1.37 2.81-2.19 2.98-.29.07-5.31.07-5.52 0zm-4.3-2.87a.72.72 0 01-.4-1.02.8.8 0 01.34-.34l.11-.06h3.63l.16.07a.7.7 0 01.4.66.72.72 0 01-.42.65c-.15.07-3.65.09-3.8.04zm-1.3-2.93a.72.72 0 01-.57-.71c0-.21.05-.33.19-.49.2-.22.22-.23 1.09-.24.49 0 .8 0 .87.02.19.05.36.2.45.36.07.13.09.17.09.35a.62.62 0 01-.23.53c-.2.19-.23.19-1.05.2-.41 0-.78 0-.82-.02zM3.6 8.46a.78.78 0 01-.44-.44.74.74 0 01.4-.92c.1-.04.17-.05.75-.05.62 0 .65 0 .76.07a.72.72 0 01.42.63c0 .22-.05.35-.18.5-.2.23-.24.25-.96.25-.48 0-.64 0-.75-.04zM1.66 5.52A.72.72 0 011.6 4.2l.13-.06h1.12c.68 0 1.15 0 1.22.03.27.07.49.38.49.69a.7.7 0 01-.43.65c-.14.06-.14.06-1.26.06a6.5 6.5 0 01-1.22-.04z";
const mdiGesturePinch = "";
const mdiVersus = "M16.08 6.887c-.687 0-1.263.121-1.731.36a2.633 2.633 0 00-1.106 1.062 3.167 3.167 0 00-.395 1.58c0 .502.103.972.308 1.411.21.434.489.786.84 1.054s.906.516 1.662.745c.844.259 1.376.445 1.595.557.22.107.383.247.49.417.107.171.162.378.162.622 0 .414-.155.763-.463 1.046-.307.278-.728.417-1.264.417-1.083 0-1.724-.684-1.919-2.055l-1.734.204c.244 2.454 1.444 3.683 3.6 3.683 1.22 0 2.116-.318 2.686-.952.576-.634.863-1.42.863-2.35 0-.645-.104-1.19-.313-1.638a2.735 2.735 0 00-.915-1.106c-.395-.288-1.04-.562-1.933-.82-.844-.24-1.383-.459-1.618-.659a.932.932 0 01-.35-.738c0-.297.13-.545.388-.745.258-.2.627-.3 1.105-.3s.845.113 1.104.342c.258.23.429.632.507 1.208l1.776-.095c-.034-1.044-.341-1.846-.922-2.407-.58-.561-1.388-.843-2.422-.843zm-12.195.184l3.138 10.727h1.904l3.146-10.727h-1.889l-2.152 7.94-2.224-7.94z";

export default {
    name: "Mdi",
    icons: {
        mdiAbTesting,
        mdiAccountBoxMultipleOutline,
        mdiAccountOutline,
        mdiArrowCollapseVertical,
        mdiArrowExpand,
        mdiArrowRightCircle,
        mdiArrowSplitHorizontal,
        mdiBookmark,
        mdiBookmarkMultipleOutline,
        mdiBookmarkPlusOutline,
        mdiCellphone,
        mdiCheckerboard,
        mdiChevronLeft,
        mdiChevronLeftCircleOutline,
        mdiChevronRight,
        mdiChevronRightCircleOutline,
        mdiCompare,
        mdiEmoticonHappyOutline,
        mdiEmoticonSadOutline,
        mdiFilterOutline,
        mdiFolderMultipleOutline,
        mdiFormatListBulletedSquare,
        mdiForumOutline,
        mdiGrid,
        mdiGridLarge,
        mdiHeart,
        mdiHeartMultipleOutline,
        mdiHeartOutline,
        mdiHelpCircleOutline,
        mdiHomeOutline,
        mdiImageOutline,
        mdiLock,
        mdiMenuDown,
        mdiPalette,
        mdiPlanmasterLogo,
        mdiPlayBoxOutline,
        mdiPrinter,
        mdiRestore,
        mdiStarOutline,
        mdiStar,
        mdiThumbDownOutline,
        mdiThumbUpOutline,
        mdiThumbDown,
        mdiThumbUp,
        mdiToothOutline,
        mdiTooth,
        mdiTrashCanOutline,
        mdiTrophyVariant,
        mdiVersus,
        mdiViewAgendaOutline,
        mdiRadioboxMarked,
        mdiRadioboxBlank,
        mdiSale,
        mdiCheck,
        mdiFullscreen,
        mdiFullscreenExit,
        mdiWalletGiftcard,
        mdiBarcodeScan,
        mdiContentSaveOutline,
        mdiEmailSendOutline,
        mdiFolderClockOutline,
        mdiEmailOutline,
        mdiEmailOpenOutline,
        mdiCommentProcessingOutline,
        mdiTrophyOutline,
        mdiAlertDecagramOutline,
        mdiHistory,
        mdiCreditCardOutline,
        //mdiFilePdfOutline,
        mdiFileOutline,
        mdiMovieOpenPlayOutline,
        mdiCalculatorVariantOutline,
        mdiGiftOutline,
        mdiSpeedometer,
        mdiAlert,
        mdiAlertOutline,
        mdiPlay,
        mdiPlayCircleOutline,
        mdiHumanMaleBoard,
        mdiFileDocumentOutline,
        mdiCheckboxBlankOutline,
        mdiCheckboxMarkedOutline,
        mdiLockOpenVariant,
    },
    props: {
        size: {
            type: [String, Number],
            default: () => 22,
        },
        fill: {
            type: String,
            default: () => "currentColor",
        },
        rotate: {
            type: Number,
            default: () => 0,
        },
        viewBox: {
            type: String,
            default: () => "0 0 24 24",
        },
    },
    methods: {
        /** @type {() => string|never} */
        validateDefaultSlot() {
            if (!isDef(this.$slots.default)) {
                throw new Error("Empty icon");
            }

            /** @type {string} */
            const text = this.$slots.default[0].text.trim();

            if (text.substring(0, 3) === "mdi") return text;

            return camelcase(`mdi-${text}`);
        },
        /** @type {(item: string) => string|never} */
        validateIcon(item) {
            // const icon = require("@mdi/js")[item]; // Lazy alternative.
            const icon = String(this.$options.icons[item]);

            if (!isDef(icon)) {
                throw new Error(`Import icon before use: ${name}`);
            }

            return icon;
        },
        /** @type {(color: string) => void} */
        fillWithColor(color) {
            this.fill = color;
        },
    },
    computed: {
        /** @type {import('vue').ComputedOptions<string>} */
        icon() {
            try {
                const item = this.validateDefaultSlot();
                const icon = this.validateIcon(item);

                return icon;
            } catch(error) {
                captureException(error);

                this.fillWithColor("red");

                const errorSvg =
                    "M21,5V11.59L18,8.58L14,12.59L10,8.59L6,12.59L3,9.58V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5M18,11.42L21,14.43V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V12.42L6,15.41L10,11.41L14,15.41";

                return errorSvg;
            }
        },
    },
};
</script>
